import { render } from "./MoatList.vue?vue&type=template&id=5ccf0f04"
import script from "./MoatList.vue?vue&type=script&lang=js"
export * from "./MoatList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__